var freeGiftDrawerRefreshPending = false;
var autoFreeGiftReconcilePromise = null;
var autoFreeGiftReconcileRequested = false;
var autoFreeGiftRetryCount = 0;
var cachedAutoFreeGiftConfig = null;
var diamondVariantRefreshPending = false;
var AUTO_DIAMOND_PROP = '_auto_diamond';
var cartQuantityUpdateInFlight = false;
var CART_QUANTITY_EVENT_NAMESPACE = '.cdkCartQuantity';

// DEFINE THIS GLOBAL FLAG OUTSIDE of $(document).ready
var $isAddingToCart = false;




function upsellAddToCart(items) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items: items }, // Send items array as data
        dataType: 'json',
        success: function(itemData) {
            UpdateCartDrawer();
            // Successful AJAX request. You can update your cart UI or show a success message.
            $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').hide();
            $('.cdk_product_upsell_container .cdk_upsell_btn').removeClass('upsell_btn_loading');
            $('html').addClass('js-drawer-open lock-scroll');
            $('#CartDrawer').addClass('drawer--is-open');
        },
        error: function(XMLHttpRequest, textStatus) {
            // Handle errors, for example, show an error message
            console.error('Error adding item to cart:', textStatus);
        }
    });
}
  
// =========================================================================
// REVISED AJAX CART ADDITION FUNCTION
// =========================================================================
function addToCart(formData) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(itemData) {
      // 1. Reset the global flag
      $isAddingToCart = false; 

      // 2. Reset the main button state
      var $mainButton = $('#btnAddtoCart');
      $mainButton.prop('disabled', false); 
      var defaultText = $mainButton.find('[data-add-to-cart-text]').data('default-text') || 'הוספה לסל הקניות';
      $mainButton.find('[data-add-to-cart-text]').text(defaultText); 
      
      // 3. Reset the sticky button state
      $('.btn_sticky_act').removeClass('disabled').text('הוספה לסל הקניות');
      
      // 4. Open and Update Cart Drawer
      $('html').addClass('js-drawer-open lock-scroll');
      $('#CartDrawer').addClass('drawer--is-open');
      UpdateCartDrawer(); // <-- Calls the revised update function
      
    },
    error: function(XMLHttpRequest, textStatus) {
      // Handle error (e.g., variant out of stock)
      // 1. Reset the global flag
      $isAddingToCart = false; 
      
      // 2. Reset the main button state
      var $mainButton = $('#btnAddtoCart');
      $mainButton.prop('disabled', false); 
      var defaultText = $mainButton.find('[data-add-to-cart-text]').data('default-text') || 'הוספה לסל הקניות';
      $mainButton.find('[data-add-to-cart-text]').text(defaultText); 
      
      // 3. Reset the sticky button state
      $('.btn_sticky_act').removeClass('disabled').text('הוספה לסל הקניות');

      console.error('Error adding item to cart:', textStatus);
      
      // Optionally show a notification of the error
    }
  });
}
  
  function updateCartWithItems(cartData) {
    return $.ajax({
      type: 'POST',
      url: '/cart/update.js', // Shopify's cart update endpoint
      data: {
        updates: cartData,
      },
      dataType: 'json'
    }).then(function (cart) {
      return UpdateCartDrawer().then(function () {
        return cart;
      });
    });
  }

function getCartDrawerRefreshUrl() {
  // The cart page still needs its page form refreshed. Everywhere else can use
  // Shopify's much smaller Section Rendering response.
  if ($('#CartPageForm').length) {
    return window.location.pathname;
  }

  var root = (
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
  ) || '/';

  return root + '?sections=cart-drawer-refresh';
}

function syncCartQuantityControlsDisabled() {
  var isDisabled =
    cartQuantityUpdateInFlight ||
    freeGiftDrawerRefreshPending ||
    $('.cdk_data_main_cart').hasClass('loading');

  $('.cdk_cart__item .quantity__plus, .cdk_cart__item .quantity__minus')
    .prop('disabled', isDisabled);
}

function clearCartDrawerLoadingState() {
  if (!freeGiftDrawerRefreshPending) {
    $('.cdk_data_main_cart').removeClass('loading');
    $('.cart-spinner-overlay').remove();
    $('.cart__checkout').removeClass('disabled');
  }

  syncCartQuantityControlsDisabled();
}

function UpdateCartDrawer(){ 
  var isCartPage = $('#CartPageForm').length > 0;

  return $.ajax({
    url: getCartDrawerRefreshUrl(),
    type: 'GET',
    dataType: isCartPage ? 'html' : 'json',
    success: function(data) {
      var responseHtml = isCartPage
        ? data
        : data && data['cart-drawer-refresh'];

      if (!responseHtml) {
        console.error("Failed to load cart drawer section HTML.");
        return;
      }

      // 1. Safely parse the fetched HTML data
      var $parsedHTML = $('<div>').html(responseHtml);

      // 2. Find the new content for the cart drawer form (inner HTML)
      var $newDrawerContent = $parsedHTML.find('#CartDrawerForm').html();

      // 3. Update the content of the *current* #CartDrawerForm
      if ($newDrawerContent) {
        $('#CartDrawerForm').html($newDrawerContent);

        // 4. CRITICAL: Re-initialize Streamline theme scripts (initGlobals)
        // This is necessary to bind events to the newly loaded content
        if (typeof theme !== 'undefined' && typeof theme.initGlobals === 'function') {
            theme.initGlobals(); 
            console.log("theme.initGlobals() called to rebind cart events.");
        }
      } else {
        console.error("Failed to find #CartDrawerForm content in fetched HTML.");
      }
      
      // 5. Update the Cart Page Form (if on the cart page)
      var $newCartPageContent = $parsedHTML.find('#CartPageForm').html();
      if ($newCartPageContent) {
        $('#CartPageForm').html($newCartPageContent);
      }
    },
    error: function(xhr, status, error) {
      console.error("Error fetching cart data to update cart drawer:", status, error);
    },
    complete: function() {
      // Never leave the cart unusable when a slow or interrupted request fails.
      clearCartDrawerLoadingState();
      updateCartItemCount();
    }
  });
}

function getAutoFreeGiftConfig() {
  var $bar = $('.free-gift-wrapper');
  if ($bar.length) {
    var giftVariantId = Number($bar.data('gift-variant-id'));
    var threshold = Number($bar.data('gift-threshold'));

    if (giftVariantId && threshold) {
      cachedAutoFreeGiftConfig = {
        giftVariantId: giftVariantId,
        threshold: threshold
      };
    }
  }

  return cachedAutoFreeGiftConfig;
}

function getAutoFreeGiftItems(cartData, giftVariantId) {
  if (!cartData || !Array.isArray(cartData.items)) return [];

  return cartData.items.filter(function (item) {
    return (
      Number(item.variant_id) === giftVariantId &&
      item.properties &&
      String(item.properties._free_gift) === 'true'
    );
  });
}

function getAutoFreeGiftQualifyingTotal(cartData, giftVariantId) {
  if (!cartData || !Array.isArray(cartData.items)) return 0;

  return cartData.items.reduce(function (total, item) {
    var isGiftVariant = Number(item.variant_id) === giftVariantId;
    var isAutoGift =
      isGiftVariant &&
      item.properties &&
      String(item.properties._free_gift) === 'true';

    if (isAutoGift) return total;

    var qualifyingLinePrice = Number(item.final_line_price || 0);

    // Shopify can apply the automatic gift discount to a customer-paid line
    // when that customer also buys the same Love Bracelet variant. Count that
    // paid line at its pre-discount cart price so the qualification state does
    // not oscillate while the promotional line is present.
    if (isGiftVariant) {
      qualifyingLinePrice = Math.max(
        qualifyingLinePrice,
        Number(item.original_line_price || 0)
      );
    }

    return total + qualifyingLinePrice;
  }, 0);
}

function setAutoFreeGiftLoading(isLoading) {
  freeGiftDrawerRefreshPending = isLoading;
  $('.cdk_data_main_cart').toggleClass('loading', isLoading);
  $('.cart__checkout').toggleClass('disabled', isLoading);

  if (isLoading) {
    if (!$('.cart-spinner-overlay').length) {
      $('.drawer__inner').append(
        '<span class="cart-spinner-overlay"><span class="cart-spinner"></span></span>'
      );
    }
  } else {
    $('.cart-spinner-overlay').remove();
  }

  syncCartQuantityControlsDisabled();
}

function autoFreeGiftRequest(options) {
  var attempt = 0;

  function run() {
    attempt++;

    return $.ajax(options).catch(function (error) {
      if (attempt >= 3) {
        throw error;
      }

      return new Promise(function (resolve) {
        setTimeout(resolve, attempt * 400);
      }).then(run);
    });
  }

  return run();
}

function fetchLatestCartForAutoGift() {
  return autoFreeGiftRequest({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    cache: false
  });
}

async function reconcileAutoFreeGiftOnce() {
  var config = getAutoFreeGiftConfig();
  if (!config) return false;

  var changed = false;

  for (var verificationAttempt = 0; verificationAttempt < 4; verificationAttempt++) {
    var cartData = await fetchLatestCartForAutoGift();
    var autoGiftItems = getAutoFreeGiftItems(cartData, config.giftVariantId);
    var qualifyingTotal = getAutoFreeGiftQualifyingTotal(
      cartData,
      config.giftVariantId
    );
    var qualifies = qualifyingTotal >= config.threshold;

    if (qualifies && autoGiftItems.length === 1 && autoGiftItems[0].quantity === 1) {
      return changed;
    }

    if (!qualifies && autoGiftItems.length === 0) {
      return changed;
    }

    setAutoFreeGiftLoading(true);

    if (qualifies && autoGiftItems.length === 0) {
      await autoFreeGiftRequest({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          items: [{
            id: config.giftVariantId,
            quantity: 1,
            properties: { _free_gift: 'true' }
          }]
        }
      });
    } else {
      var updates = {};

      autoGiftItems.forEach(function (item, index) {
        updates[item.key] = qualifies && index === 0 ? 1 : 0;
      });

      await autoFreeGiftRequest({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: {
          updates: updates
        }
      });
    }

    changed = true;
  }

  throw new Error('Free gift cart state did not settle after verification');
}

window.reconcileAutoFreeGift = function () {
  autoFreeGiftReconcileRequested = true;

  if (autoFreeGiftReconcilePromise) {
    return autoFreeGiftReconcilePromise;
  }

  autoFreeGiftReconcilePromise = (async function () {
    var cartChanged = false;

    while (autoFreeGiftReconcileRequested) {
      autoFreeGiftReconcileRequested = false;
      cartChanged = (await reconcileAutoFreeGiftOnce()) || cartChanged;
    }

    autoFreeGiftRetryCount = 0;

    if (cartChanged) {
      await UpdateCartDrawer();
    }
  })()
    .catch(function (error) {
      console.error('Unable to reconcile automatic free gift:', error);

      if (autoFreeGiftRetryCount < 3) {
        autoFreeGiftRetryCount++;
        setTimeout(function () {
          window.reconcileAutoFreeGift();
        }, autoFreeGiftRetryCount * 1000);
      }
    })
    .finally(function () {
      autoFreeGiftReconcilePromise = null;
      setAutoFreeGiftLoading(false);

      if (autoFreeGiftReconcileRequested) {
        window.reconcileAutoFreeGift();
      }
    });

  return autoFreeGiftReconcilePromise;
};

function handleFreeGift() {
  return window.reconcileAutoFreeGift();
}

var DIAMOND_COLORS = ['whitediamond', 'golddiamond'];

function cartHasDiamondColor(cartData) {
  if (!cartData || !cartData.items) return false;

  return cartData.items.some(function (item) {
    if (!item.options_with_values) return false;

    return item.options_with_values.some(function (opt) {
      var optionName = String(opt.name || '').toLowerCase();
      var optionValue = String(opt.value || '').toLowerCase();

      return (
        optionName === 'color' &&
        DIAMOND_COLORS.includes(optionValue)
      );
    });
  });
}


function hasAutoDiamond(cartData, diamondVariantId) {
  if (!cartData || !cartData.items) return false;

  return cartData.items.some(function (item) {
    return (
      diamondVariantId.includes(Number(item.variant_id)) &&
      item.properties &&
      item.properties[AUTO_DIAMOND_PROP] === 'true'
    );
  });
}

function getAutoDiamondItem(cartData, diamondVariantId) {
  if (!cartData || !cartData.items) return null;

  return cartData.items.find(function (item) {
    return (
      diamondVariantId.includes(Number(item.variant_id)) &&
      item.properties &&
      item.properties[AUTO_DIAMOND_PROP] === 'true'
    );
  }) || null;
}


function handleDiamondVariant(cartData) {
  var $drawer = $('#CartDrawer');
  if (!$drawer.length || !cartData) return;

  // var diamondVariantId = Number($drawer.data('diamond-variant-id'));
  var diamondVariantId = ($drawer.data('diamond-variant-id') || '')
  .toString()
  .split(',')
  .map(function(id) {
    return Number(id.trim());
  })
  .filter(function(id) {
    return !isNaN(id);
  });
  if (!diamondVariantId.length) return;// feature disabled

  var hasDiamondProduct = cartHasDiamondColor(cartData);
  var autoDiamondExists = hasAutoDiamond(cartData, diamondVariantId);

  // ============================
  // ADD DIAMOND VARIANT
  // ============================
  if (
    hasDiamondProduct &&
    !autoDiamondExists &&
    !diamondVariantRefreshPending
  ) {
    diamondVariantRefreshPending = true;
    var itemsToAdd = diamondVariantId.map(function(id) {
      return {
        id: id,
        quantity: 1,
        properties: {
          [AUTO_DIAMOND_PROP]: 'true'
        }
      };
    });
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: {
        items: itemsToAdd
      }
    }).done(function () {
      setTimeout(function () {
        UpdateCartDrawer();
        diamondVariantRefreshPending = false;
      }, 300);
    });

    return;
  }

  // ============================
  // REMOVE DIAMOND VARIANT
  // ============================
  if (
    !hasDiamondProduct &&
    autoDiamondExists &&
    !diamondVariantRefreshPending
  ) {
    diamondVariantRefreshPending = true;

    var diamondItem = getAutoDiamondItem(cartData, diamondVariantId);
    if (!diamondItem) {
      diamondVariantRefreshPending = false;
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: diamondItem.key,
        quantity: 0
      }
    }).done(function () {
      setTimeout(function () {
        UpdateCartDrawer();
        diamondVariantRefreshPending = false;
      }, 300);
    });
  }
}

function updateCartItemCount() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartData) {
      handleFreeGift(cartData);
      handleDiamondVariant(cartData);
      // Extract the item count from the cart data
      var cartTotPrice = cartData.total_price;
      //console.log('cartData::'+cartTotPrice);
      var itemCount = cartData.item_count;
      if(itemCount == 0){
        $('#CartDrawer').addClass('is-empty');
      }else{
        $('#CartDrawer').removeClass('is-empty');
      }
      if (cartTotPrice >= 50000){
        
      }
      else if (cartTotPrice >= 75000){
        
      }
      else if (cartTotPrice >= 100000){
        
      }
 
      // Update the cart item count on the website
      $('.cart-link__bubble-num').text(itemCount);
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      // Handle errors, show a specific error message if needed
      //console.error('Error fetching cart data:', textStatus, errorThrown);
    }
  });
}  
$(document).ready(function () { 
  // Quantity plus

  $(document)
    .off(
      'click' + CART_QUANTITY_EVENT_NAMESPACE,
      '.cdk_cart__item .quantity__plus'
    )
    .on(
      'click' + CART_QUANTITY_EVENT_NAMESPACE,
      '.cdk_cart__item .quantity__plus',
      function (adev) {
    adev.stopPropagation();

    if (
      cartQuantityUpdateInFlight ||
      freeGiftDrawerRefreshPending ||
      $('.cdk_data_main_cart').hasClass('loading')
    ) {
      adev.preventDefault();
      adev.stopImmediatePropagation();
      return;
    }

    var updatedCartData = {};
    
      var qtySelector = $(this).parents('.main-qty-selector').find('input');
      var thisGroupId = qtySelector.attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
    // console.log('qtySelector::'+qtySelector);
    // Get the current quantity value
    var qtyUnit = parseInt(qtySelector.val());
    //console.log('qtyUnit::'+qtyUnit);
      // Increment the quantity value
    var newQuantity = qtyUnit + 1;
    //  console.log('newQuantity::'+newQuantity);
    // Update the input field with the new quantity
    $(qtySelector).val(newQuantity);

    $('.cdk_data_main_cart').addClass('loading');
    $('.cart__checkout').addClass('disabled');
    cartQuantityUpdateInFlight = true;
    syncCartQuantityControlsDisabled();

        // Loop through each cart item and build the updatedCartData object
    $('.cdk_cart__item').each(function () {
      var eachGroupId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-id');
        
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
      updateCartWithItems(updatedCartData)
        .fail(function () {
          clearCartDrawerLoadingState();
        })
        .always(function () {
          cartQuantityUpdateInFlight = false;
          syncCartQuantityControlsDisabled();
        });
  });

    // Quantity minus

  $(document)
    .off(
      'click' + CART_QUANTITY_EVENT_NAMESPACE,
      '.cdk_cart__item .quantity__minus'
    )
    .on(
      'click' + CART_QUANTITY_EVENT_NAMESPACE,
      '.cdk_cart__item .quantity__minus',
      function (reev) {
    reev.stopPropagation();

    if (
      cartQuantityUpdateInFlight ||
      freeGiftDrawerRefreshPending ||
      $('.cdk_data_main_cart').hasClass('loading')
    ) {
      reev.preventDefault();
      reev.stopImmediatePropagation();
      return;
    }

    var updatedCartData = {};
    
      var qtySelector = $(this).parents('.main-qty-selector').find('input');
      var thisGroupId = qtySelector.attr('data-groupid');
    //console.log('thisGroupId::'+thisGroupId);
      // console.log('qtySelector::'+qtySelector);
    // Get the current quantity value
    var qtyUnit = parseInt(qtySelector.val());
    //console.log('qtyUnit::'+qtyUnit);
      // Increment the quantity value
      if(qtyUnit > 0){
        var newQuantity = qtyUnit - 1;    
      }else{
        var newQuantity = qtyUnit;
      }
    
    //  console.log('newQuantity::'+newQuantity);
    // Update the input field with the new quantity
    $(qtySelector).val(newQuantity);

    $('.cdk_data_main_cart').addClass('loading');
    $('.cart__checkout').addClass('disabled');
    cartQuantityUpdateInFlight = true;
    syncCartQuantityControlsDisabled();

        // Loop through each cart item and build the updatedCartData object
    $('.cdk_cart__item').each(function () {
      var eachGroupId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-groupid');
      if (eachGroupId == thisGroupId) {
        var thisVarId = $(this).find('.main-qty-selector').find('input.js-qty__num').attr('data-id');
        
        updatedCartData[thisVarId] = newQuantity;
      }
    }); 
      updateCartWithItems(updatedCartData)
        .fail(function () {
          clearCartDrawerLoadingState();
        })
        .always(function () {
          cartQuantityUpdateInFlight = false;
          syncCartQuantityControlsDisabled();
        });
  });



  // Consolidated handler for BOTH the form submit button AND the sticky button
  $('#btnAddtoCart, .btn_sticky_act').off('click').on('click', function(event) {
  event.preventDefault(); 

  // Check the global flag to prevent a second execution
  if ($isAddingToCart) {
    console.warn('Skipping submission: Already running.');
    return;
  }

  $isAddingToCart = true;

  var $button = $(this);
  var $form = $('.product-single__form'); // Always target the main form

  // --- UI Update: Disable and set loading text on BOTH buttons ---
  var loadingText = 'טוען...';

  // Disable the form button
  $('#btnAddtoCart').prop('disabled', true);
  $('#btnAddtoCart').find('[data-add-to-cart-text]').text(loadingText); 

  // Disable the sticky button
  $('.btn_sticky_act').addClass('disabled').text(loadingText); 
  // ---------------------------------------------------------------

  var formData = $form.serialize();
  console.log('Sending Add to Cart Request...');

  addToCart(formData); 
  });
 


  $(document).on('click', '[aria-controls="CartDrawer"]', function (ev) {
    ev.preventDefault(); 
    $('html').addClass('js-drawer-open lock-scroll');
    $('#CartDrawer').addClass('drawer--is-open');
  });
  
  $(document).on('click', '.drawer__close-button', function (evs) {
    evs.preventDefault(); 
    $('html').removeClass('js-drawer-open lock-scroll');
    $('#CartDrawer').removeClass('drawer--is-open');
  })

  $('.variant-input-wrap .variant-input label').click(function() { 
    var thisValInp = parseFloat($('input#timestamp').val());
    var thisValInp = thisValInp + 27;
    $('input#timestamp').val(thisValInp); 
  });
  $(document).on('click', '#addTocartBtn_overlay', function () {
      $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').show();
  })
  
  $(document).on('click', '.cdk_product_upsell_container .up_btn_close', function () {
      $('.cdk_product_upsell_overlay, .cdk_product_upsell_container').hide();
      $('.product-single__form #btnAddtoCart').trigger('click');
  })
  
  $(document).on('click', '.cdk_product_upsell_container .cdk_upsell_btn', function () {
    $(this).addClass('upsell_btn_loading');
      var items = []; 
      var variantId1 = $(this).attr('upsell-data-variant');
      var variantTS1 = $(this).attr('upsell-timestamp');
        
      var variantId2 = $(this).attr('product-data-variant');
      var variantTS2 = $(this).attr('product-timestamp');
      
      // Add both variants to the items array with a quantity of 1 each
      items.push({ quantity: 1, id: variantId1, properties: {'timestamp': variantTS1} });
      items.push({ quantity: 1, id: variantId2, properties: {'timestamp': variantTS2} });
      
      // Call addToCart function with items array
      upsellAddToCart(items);
  });
  
});
function updateCartGiftItemCount() {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cartData) {
      
      // Update the cart item count on the website
      $('.cart-link__bubble-num').text(itemCount);
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      // Handle errors, show a specific error message if needed
      //console.error('Error fetching cart data:', textStatus, errorThrown);
    }
  });
} 
function UpdateCartDrawerWithFreeGift(){ 
  return UpdateCartDrawer();
}
function updateButtonState(button, isAvailable) {
  if (isAvailable) {
    button.innerHTML = 'Add Now <span class="loading_spinner"></span>';
    button.classList.remove('disabled');
    button.style.pointerEvents = 'auto';
    button.style.opacity = '1';
  } else {
    button.innerHTML = 'Sold Out <span class="loading_spinner"></span>';
    button.classList.add('disabled');
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.5';
  }
}
function initCartAddonProductListeners(scope) {
  const container = scope || document; 
  
  container.querySelectorAll('.cart_addon_product_main').forEach((addonMain) => {
    const productWrapper = addonMain.querySelector('.cart_addon_product_product');
    const addButton = addonMain.querySelector('.add_on_btn');
    if (!productWrapper || !addButton) return;

    // Find the currently checked radio
    const checkedRadio = addonMain.querySelector('input[type=radio][name^="color-"]:checked');
    
    if (checkedRadio) {
      const label = checkedRadio.closest('label');
      if (label) {
        const selectedVariantId = label.getAttribute('data-variant-id');
        const isAvailable = label.getAttribute('data-available') === 'true';

        // Set initial variant ID
        productWrapper.setAttribute('variant__id', selectedVariantId);

        // Sync initial button state
        updateButtonState(addButton, isAvailable);
      }
    }
  });
}
document.addEventListener('click', function(event) {
  
  // 1. Handle Close Button
  const closeButton = event.target.closest('.close-btn');
  if (closeButton) {
    event.preventDefault();
    const addonMainToHide = closeButton.closest('.cart_addon_product_main');
    
    if (addonMainToHide) {
      addonMainToHide.style.display = 'none';
    }
    return; 
  }

  // 2. Handle Add Button
  const addButton = event.target.closest('.add_on_btn');
  // If they didn't click the add button, or if it's disabled/already clicked, stop here
  if (!addButton || addButton.classList.contains('disabled') || addButton.classList.contains('clicked')) return;
  
  event.preventDefault(); 
  addButton.classList.add('clicked');

  const addonMain = addButton.closest('.cart_addon_product_main');
  const productWrapper = addonMain?.querySelector('.cart_addon_product_product');
  let selectedVariantId = productWrapper?.getAttribute('variant__id');

  if (!selectedVariantId) {
      alert('Please select a variant.');
      addButton.classList.remove('clicked'); // Reset button state if validation fails
      return;
  }

  // FIXED: Define the correct data payload structure for Shopify's AJAX API
  const cartData = {
    items: [
      {
        id: parseInt(selectedVariantId, 10),
        quantity: 1
      }
    ]
  };

  $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: JSON.stringify(cartData), // Send as JSON string
      contentType: "application/json", // Set correct content type for Shopify
      dataType: "json",
      success: function(data) {
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            bubbles: true,
            detail: {
              product: data
            }
          })
        );
        
        setTimeout(function() {
          addButton.classList.remove('clicked');
          UpdateCartDrawerWithFreeGift();
        }, 300);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        addButton.classList.remove('clicked');
        if (jqXHR.status === 400 && jqXHR.responseJSON) {
          alert(jqXHR.responseJSON.message);
        } else if (jqXHR.status === 422 && jqXHR.responseJSON) {
          alert(jqXHR.responseJSON.description);
        } else {
          alert('Something went wrong adding the item to the cart.');
        }
      }
    });
});
initCartAddonProductListeners();
$(document).ready(function () {
  $.getJSON('/cart.js', function (cart) {
    handleFreeGift(cart);
  });
});
